// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__29T3T","header":"ReportDetails_header__gEpJd","title":"ReportDetails_title__2jX6w","left":"ReportDetails_left__24hUI"};